import { render, staticRenderFns } from "./ProjectNavigationArchive.vue?vue&type=template&id=08d77176"
import script from "./ProjectNavigationArchive.vue?vue&type=script&lang=js"
export * from "./ProjectNavigationArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports